<div class="download-expose">
    <section class="head">
        <article class="subtitle">{{ 'SHARED_COMPONENT.EXPOSE_DOWNLOAD' | translate }}</article>
        <button mat-icon-button mat-dialog-close [disabled]="isLoading">
            <mat-icon>close</mat-icon>
        </button>
    </section>

    <section class="view">
        @switch (currentViewType) {
            @case (0) {
                <div>
                    <mat-form-field>
                        <mat-label>{{ 'SHARED_COMPONENT.LANGUAGE' | translate }}</mat-label>
                        <mat-select [(ngModel)]="selectedCultureInfo">
                            <mat-option [value]="'en-US'">{{ 'SHARED_COMPONENT.LANG_EN' | translate }}</mat-option>
                            <mat-option [value]="'en-GB'"
                                >{{ 'SHARED_COMPONENT.LANG_EN' | translate }},
                                {{ 'SHARED_COMPONENT.UNITED_KINGDOM' | translate }}</mat-option
                            >
                            <mat-option [value]="'fr-FR'">{{ 'SHARED_COMPONENT.LANG_FR' | translate }}</mat-option>
                            <mat-option [value]="'de-DE'">{{ 'SHARED_COMPONENT.LANG_DE' | translate }}</mat-option>
                            <mat-option [value]="'sv-SE'">{{ 'SHARED_COMPONENT.LANG_SV' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            }
            @case (1) {
                <div class="loading">
                    <article>{{ 'SHARED_COMPONENT.EXPOSE_DOWNLOAD_MESSAGE' | translate }}</article>
                    <loading-indicator [isPermanent]="true" />
                </div>
            }
            @case (2) {
                <div class="done">
                    <ak-message-box [type]="'success'">
                        {{ 'SHARED_COMPONENT.EXPOSE_DOWNLOAD_SUCCESS' | translate }}
                    </ak-message-box>
                </div>
            }
            @case (3) {
                <div class="done">
                    <ak-message-box [type]="'error'">
                        {{ 'SHARED_COMPONENT.EXPOSE_DOWNLOAD_ERROR' | translate }}
                    </ak-message-box>
                </div>
            }
        }
    </section>

    <section class="actions">
        @if (currentViewType !== 1) {
            <button matButton="outlined" mat-dialog-close>
                {{ 'SHARED_COMPONENT.CLOSE' | translate }}
            </button>
        }
        @if (currentViewType === 0) {
            <button matButton="filled" clickAndKeydown (actionTriggered)="languageSelected()">
                {{ 'SHARED_COMPONENT.DOWNLOAD' | translate }}
            </button>
        }
    </section>

    <a style="display: none" #downloadLink></a>
</div>
